"use client";

import React from "react";

interface SectionDividerProps {
  topColorClass?: string;
  bottomColorClass?: string;
  showOrangeLine?: boolean;
}

export function SectionDivider({ topColorClass, bottomColorClass, showOrangeLine }: SectionDividerProps) {
  return (
    <div
      className="relative w-full z-20 pointer-events-none bg-transparent"
      style={{ height: "5vw" }}
    >
      {/* Top shape - extends the previous section downwards */}
      {topColorClass && (
        <svg
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
          className={`absolute top-0 left-0 w-full h-[5vw] ${topColorClass} transition-colors duration-500`}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0 V10 H450 C490 10, 510 85, 550 85 H1000 V0 Z"
            fill="currentColor"
          />
          {showOrangeLine && (
            <path
              d="M0 10 H450 C490 10, 510 85, 550 85 H1000"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-orange-500/40 dark:text-transparent transition-opacity duration-500"
            />
          )}
        </svg>
      )}

      {/* Bottom shape - shapes the top of the next section */}
      {bottomColorClass && (
        <svg
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
          className={`absolute bottom-0 left-0 w-full h-[5vw] ${bottomColorClass} transition-colors duration-500`}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 100 V0 H450 C490 0, 510 85, 550 85 H1000 V100 Z"
            fill="currentColor"
          />
          {showOrangeLine && (
            <path
              d="M0 0 H450 C490 0, 510 85, 550 85 H1000"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-orange-500/40 dark:text-transparent transition-opacity duration-500"
            />
          )}
        </svg>
      )}
    </div>
  );
}

